import { RowDataPCComponentParameter } from "../../components/PCComponentParameterPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the PCComponentParameterTable factory
 */
class PCComponentParameterRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/pc-components/read-range-params"
        this.accessData = "params"
    }

    create(params: any): RowDataPCComponentParameter {
        const rowDataOrder: RowDataPCComponentParameter = {
            id: params.id,
            value: params.value,
            label: params.label,
            type: params.type,
            category: params.category,
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let pcComponentParameterRow: PCComponentParameterRow | null = null;

export default function getPCComponentParameterRow(): PCComponentParameterRow {
    if (pcComponentParameterRow === null)
        pcComponentParameterRow = new PCComponentParameterRow()
    return pcComponentParameterRow
}